import { NgModule, ApplicationRef } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalDialogComponent } from './components/modal-dialog/bprmodal-dialog.component';

import {BprDialogService} from "./services/bpr-dialog.service";

import { BprAuthGuardService } from "./services/bprAuthGuardService";
import { SharedModule } from '../shared';


@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    providers: [
        BprAuthGuardService,
        BprDialogService
    ],
    declarations: [
        ModalDialogComponent
    ],
    exports: [
        ModalDialogComponent
    ]
})
export class AppCommonModule {
  constructor(applicationRef: ApplicationRef) {
    //for ng2-bootstrap-modal in angualar 5
    //Object.defineProperty(applicationRef, '_rootComponents', { get: () => applicationRef['components'] });
  }
}
